/**
 * Default for {@link WalkInModel.enabled}.
 * Walk-in path is inert until enabled.
 */
const DEFAULT_WALK_IN_ENABLED = false;

export default DEFAULT_WALK_IN_ENABLED;
